export const MessageTypes = {
  AGENT: 'AGENT',
  CUSTOMER: 'CUSTOMER'
};

export const MAX_ORDERS = 5;
